import { render } from "./indemnityModal.vue?vue&type=template&id=244b9232"
import script from "./indemnityModal.vue?vue&type=script&lang=js"
export * from "./indemnityModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__